"use client";

import NotFound from "@/app/not-found";
import { useI18n, type TranslationKey } from "@/lib/i18n";

function LocalizedText({ translationKey }: { translationKey: TranslationKey }) {
  const { t } = useI18n();
  return <>{t(translationKey)}</>;
}

function LocalizedValue({ children }: { children: React.ReactNode }) {
  const { translateText } = useI18n();
  return (
    <>{typeof children === "string" ? translateText(children) : children}</>
  );
}

const demoDataViews = new Set([
  "Prompt Optimizations",
  "Agent Health",
  "Models",
  "Fleet Agents",
]);

function inspectionText(value: string) {
  return value
    .replace(/scanning/gi, (match) =>
      match[0] === "S" ? "Inspecting" : "inspecting",
    )
    .replace(/scans/gi, (match) =>
      match[0] === "S" ? "Inspections" : "inspections",
    )
    .replace(/scan/gi, (match) =>
      match[0] === "S" ? "Inspection" : "inspection",
    );
}

function UnknownRoute() {
  return <NotFound />;
}

function shortDate(value: string) {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value.slice(0, 8);
  return date.toLocaleDateString("en-US", {
    month: "numeric",
    day: "numeric",
    year: "2-digit",
  });
}

function categorizeSdlcFinding(value: string) {
  const text = value.toLowerCase();
  if (/security|secret|vulnerab|auth|permission/.test(text)) return "Security";
  if (/test|coverage|qa|quality gate/.test(text)) return "Testing";
  if (/deploy|release|pipeline|ci\b|cd\b|build/.test(text)) return "Delivery";
  if (/dependenc|package|library|version/.test(text)) return "Dependencies";
  if (/document|readme|runbook|ownership/.test(text)) return "Documentation";
  if (/observ|monitor|logg|metric|alert/.test(text)) return "Observability";
  if (/architecture|coupling|complex|maintain|modular/.test(text))
    return "Architecture";
  return "Engineering Practice";
}

export {
  categorizeSdlcFinding,
  demoDataViews,
  inspectionText,
  LocalizedText,
  LocalizedValue,
  shortDate,
  UnknownRoute,
};
